export const GENERIC_ERROR_MESSAGE =
    'Something went wrong. Please try again.\nIf you keep seeing this message, please contact support.';

interface ProblemDetails {
    title?: string;
    detail?: string;
    traceId?: string;
    errors?: Record<string, string[]>;
}

export const getResponseErrorTitle = async (response: Response): Promise<string> => {
    try {
        switch (response.status) {
            case 400: {
                const data = (await response.json()) as ProblemDetails;

                if (data.errors) {
                    return Object.values(data.errors).flat().join('\n');
                }

                return data.detail ?? data.title ?? 'Bad request.';
            }
            case 401:
            case 403:
                return 'You are not authorized to perform this action.';
            default: {
                const data = (await response.json()) as ProblemDetails;
                return GENERIC_ERROR_MESSAGE + (data.traceId ? `\nTrace ID: ${data.traceId}` : '');
            }
        }
    } catch {
        return GENERIC_ERROR_MESSAGE;
    }
};
